module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c05-1a1d141d517b976892ca5c9f72228e32.jpg";